import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import iconSet from "./iconset.json";
import { fontAwesomeIconSet } from "./fontAwesomeIconSet.js"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Icon({ isFaIcon, size, icon, className, style, ...props }) {
  const faIcon = fontAwesomeIconSet[icon];

  return (
    <>
      {isFaIcon ? (
         <FontAwesomeIcon
                  icon={faIcon}
                  className={className}
                  style={{ fontSize: '24px', ...style }}
                  {...props} 
                />
      ) : (
        <SvgIcon {...props} style={{ fontSize: size, ...style }}>
          <path d={iconSet[icon]} />
        </SvgIcon>
      )}
    </>
  );
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
};

export default Icon;
